import { vOnClickOutside } from '@vueuse/components'
import scroll from '@/directives/scroll'
import resize from '@/directives/resize'

export default defineNuxtPlugin( (nuxt) => {
    nuxt.vueApp.directive('resize', resize)
    nuxt.vueApp.directive('scroll', scroll)
    nuxt.vueApp.directive('on-click-outside', vOnClickOutside)
})